import moment from 'moment';
import { postV2, get} from '@/tools/http';

export default {
    namespaced: true,
    state: {
        errorMessage: null,
        nextCodeRequestAt: null,
        current: null,
        confirmedTel: false,
    },
    mutations: {
        setNextCodeRequestAt: (state, v) => state.nextCodeRequestAt = v,
        setErrorMessage: (state, v) => state.errorMessage = v,
        setCurrentConfirmation: (state, v) => state.current = v,
        setConfirmedTel: (state, v) => state.confirmedTel = v,
    },
    actions: {
        loadConfirmation: async (ctx) => {
            const res = await get('profile', 'tel/confirmation');

            if (!res) {
                return;
            }

            ctx.commit('setNextCodeRequestAt', moment(res.nextCodeRequestAt));
            ctx.commit('setCurrentConfirmation', res.current);
        },
        requestNewCode: async (ctx, tel) => {
            try {
                const res = await postV2('profile', 'tel/confirmation/send', { tel }, true, { full: false, nullOnError: false });
                ctx.commit('setNextCodeRequestAt', moment(res.nextCodeRequestAt));
                ctx.commit('setErrorMessage', res.errorMessage);

                if (res.isSent) {
                    ctx.commit('setCurrentConfirmation', res.current);
                }
            } catch(res) {
                ctx.commit('setErrorMessage', res.errors[0]);
            }
        },
        applyConfirmationCode: async (ctx, code) => {
            if (ctx.state.current === null) return;

            try {
                const res = await postV2('profile', 'tel/confirmation/confirm', {
                    id: ctx.state.current.id,
                    code,
                }, true, { full: false, nullOnError: false });

                ctx.commit('setNextCodeRequestAt', moment(res.nextCodeRequestAt));
                ctx.commit('setErrorMessage', res.errorMessage);

                if (res.current.isConfirmed) {
                    ctx.commit('setConfirmedTel', res.current.tel);
                    ctx.commit('setCurrentConfirmation', null);
                } else {
                    ctx.commit('setCurrentConfirmation', res.current);
                }
            } catch(res) {
                ctx.commit('setErrorMessage', res.errors[0]);
            }
        },
        setConfirmedTel: async (ctx, tel) => {
            ctx.commit('setConfirmedTel', tel);
        },
        cancelConfirmation: (ctx) => {
            ctx.commit('setCurrentConfirmation', null);
            ctx.commit('setErrorMessage', null);
        },
        resetErrorMessage: (ctx) => {
            ctx.commit('setErrorMessage', null);
        },
    },
    getters: {
        isTelConfirmed: state => (tel) => {
            return state.confirmedTel && state.confirmedTel === tel;
        },
    },
};
